export const scheduleDictionary = [
  { name: "メール受信テスト", key: "confirmation_date", base_date: "start_date", diffrenceFromBaseDate: -345600 + 28800 },
  { name: "サーベイ配信", key: "start_date", base_date: "start_date", diffrenceFromBaseDate: 28800 },
  { name: "未回答者リマインド", key: "remind_date", base_date: "start_date", diffrenceFromBaseDate: 345600 + 28800 },
  { name: "一次締切", key: "pre_end_date", base_date: "start_date", diffrenceFromBaseDate: 360000 + 28800 },
  { name: "未回答者報告", key: "report_date", base_date: "start_date", diffrenceFromBaseDate: 604800 + 28800 },
  { name: "最終締切", key: "end_date", base_date: "start_date", diffrenceFromBaseDate: 1123200 + 28800 },
  { name: "研修日", key: "training_date", base_date: "training_date", diffrenceFromBaseDate: 36000 },
  { name: "ログイン情報送付", key: "send_login_infomation_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 },
  { name: "目標設定開始", key: "set_start_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 , onlyHasTarget:true},
  { name: "目標設定終了", key: "set_end_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 + 604800 , onlyHasTarget:true},
  { name: "上司承認開始", key: "ok_start_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 , onlyHasTarget:true},
  { name: "上司承認終了", key: "ok_end_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 + 604800*2 , onlyHasTarget:true},
  { name: "振り返り開始", key: "ok_start_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 +15552000, onlyHasTarget:true},
  { name: "振り返り終了", key: "ok_end_date", base_date: "training_date", diffrenceFromBaseDate: 25200 + 36000 + 604800*2 +15552000, onlyHasTarget:true},
]

export function getNewSchedules() {
  const schedules = {}
  scheduleDictionary.forEach(sh => {
    schedules[sh.key] = 0
  })
  return schedules
}